module.exports = __webpack_public_path__ + "fonts/roboto-all-400-italic.d1f23769.woff2";